import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';

const useStyle = makeStyles(() => ({
  root: {
    position: 'relative',
    width: '100vw',
    height: '100vh',
  },
  center: {
    textAlign: 'center',
    width: '100%',
  },
  cover: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,.6)',
    zIndex: 111,
  },
  circle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

const Loader = ({ center, cover, size, classes }) => {
  const loaderClasses = useStyle();
  const classNames = clsx(
    {
      [loaderClasses.center]: center,
      [loaderClasses.cover]: cover,
    },
    classes,
  );
  return (
    <div className={classNames}>
      <CircularProgress style={{ width: size, height: size }} />
    </div>
  );
};

Loader.defaultProps = {
  classes: undefined,
  center: false,
  cover: false,
  size: 40,
};

Loader.propTypes = {
  classes: PropTypes.string,
  center: PropTypes.bool,
  cover: PropTypes.bool,
  size: PropTypes.number,
};

const FullPageLoader = () => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.circle}>
        <Loader />
      </div>
    </div>
  );
};

export { Loader, FullPageLoader };
